import { Route, Switch, useRouteMatch } from "react-router-dom";
import DashIframe from "../components/DashIframe";

function Dashboard() {
  let { path } = useRouteMatch();
  return <>
    <Switch>
      <Route exact path={path}>
      </Route>
      <Route path={`${path}/:id`}>
        <DashIframe />
      </Route>
    </Switch></>
}

export default Dashboard;
